// import React, { useState, useRef, useEffect } from "react";
// import {
//     Popper, Paper, List, ListItem, ListItemText, TextField, InputAdornment,
//     Divider, Avatar, Box, Typography, Button
// } from "@mui/material";
// import SearchIcon from '@mui/icons-material/Search';
// import { ReactComponent as VerifiedTickN } from "../../../Assets/img/icons/Verified-icon-new.svg";
// import Chip from '@mui/material/Chip';
// import { ReactComponent as NonVerifiedTickNew } from "../../../Assets/img/icons/Non-verified-icon.svg";
// import useApi from '../../Utilities/useAPI';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { useNavigate } from 'react-router-dom';
// import CryptoJS from 'crypto-js';
// import axios from "axios";

// const GlobalSearch = ({ setOpenSearch }) => {
//     const objectId = localStorage.getItem("objectId");
//     const [searchQuery, setSearchQuery] = useState('');
//     const [searchResults, setSearchResults] = useState([]);
//     const [initialFetchDone, setInitialFetchDone] = useState(false); // flag to track if initial fetch is done
//     const [open, setOpen] = useState(true);
//     const searchRef = useRef(null);
//     const popperRef = useRef(null); // Reference for the Popper element
//     const [offset, setOffset] = useState(1);
//     const [loadingMore, setLoadingMore] = useState(false);
//     const [hasMore, setHasMore] = useState(true);
//     const { callApiFunction } = useApi();
//     const navigate = useNavigate();

//     const handleClickOutsideSearch = (event) => {
//         if (searchRef.current && !searchRef.current.contains(event.target) &&
//             popperRef.current && !popperRef.current.contains(event.target)) {
//             setOpenSearch(false);
//         }
//     };

//     useEffect(() => {
//         document.addEventListener('mousedown', handleClickOutsideSearch);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutsideSearch);
//         };
//     }, []);

//     const fetchSearchResults = async (query, offsetValue = 1, isLoadMore = false) => {
//         try {
//             setLoadingMore(true);
//             const response = await axios.get(
//                 `${process.env.REACT_APP_BACKEND_URL}/api/v1/usercontact/connection/search-get-user/`,
//                 {
//                     params: {
//                         searchParam: query,
//                         limit: 20,
//                         offset: offsetValue,
//                     },
//                     headers: {
//                         Authorization: `Bearer ${localStorage.getItem("objectId")}`,
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             if (response?.data?.status === "SUCCESS") {
//                 const newResults = response?.data?.data;
//                 console.log("newResultsscvsvas", newResults)
//                 setHasMore(newResults?.length === 20); // Check if more results available

//                 if (isLoadMore) {
//                     setSearchResults((prev) => [...prev, ...newResults]);
//                 } else {
//                     setSearchResults(newResults);
//                 }
//                 setOpen(true);
//             }
//         } catch (error) {
//             console.error("Error fetching search results:", error);
//         } finally {
//             setLoadingMore(false);
//         }
//     };

//     const handleInputChange = (event) => {
//         setSearchQuery(event.target.value);
//     };

//     // Trigger initial fetch on focus
//     const handleFocus = async () => {
//         if (!initialFetchDone) {
//             await fetchSearchResults('a');
//             setInitialFetchDone(true);
//         }
//     };

//     // Debouncing logic for search input
//     useEffect(() => {
//         const debounceSearch = setTimeout(() => {
//             if (searchQuery.trim() !== "") {
//                 setOffset(1); // Reset to first page
//                 setHasMore(true);
//                 fetchSearchResults(searchQuery, 1, false);
//             } else {
//                 setOpen(false);
//             }
//         }, 300);

//         return () => clearTimeout(debounceSearch);
//     }, [searchQuery]);

//     const handleConnectRequest = async (contactRefId, index) => {
//         const payload = {
//             userrefid: objectId, // Replace with actual objectId
//             contact_ref_id: contactRefId,
//             relationship_type: "FRIEND",
//         };

//         try {
//             const response = await callApiFunction('SendConnectRequest', payload);
//             if (response.status === "SUCCESS") {
//                 const updatedResults = [...searchResults];
//                 updatedResults[index].relationship_status = "PENDING";
//                 setSearchResults(updatedResults);
//             } else {
//                 console.error('Failed to send connection request.');
//             }
//         } catch (err) {
//             console.error('An error occurred while sending the connection request:', err);
//         }
//     };

//     const handleNavigate = (id) => {
//         const encryptedId = CryptoJS.AES.encrypt(id.toString(), 'UserDetailsSecretKey').toString();
//         navigate(`/AllCardsUser/${encodeURIComponent(encryptedId)}`);
//         setOpenSearch(false);
//     }

//     const handleScroll = (e) => {
//         const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
//         const isNearBottom = scrollHeight - scrollTop <= clientHeight + 50;

//         if (isNearBottom && !loadingMore && hasMore) {
//             const nextOffset = offset + 1;
//             setOffset(nextOffset);
//             fetchSearchResults(searchQuery, nextOffset, true);
//         }
//     };

//     return (
//         <>
//             <div ref={searchRef} className="header-search-container">
//                 <TextField
//                     placeholder="Search for People"
//                     variant="outlined"
//                     size="small"
//                     className="me-2"
//                     value={searchQuery}
//                     onChange={handleInputChange}
//                     onFocus={handleFocus}
//                     InputProps={{
//                         startAdornment: (
//                             <InputAdornment position="start">
//                                 <div className="icon-svg-24 flex-center ml-0">
//                                     <SearchIcon className="icon-color" />
//                                 </div>
//                             </InputAdornment>
//                         ),
//                     }}
//                     style={{ width: '320px' }}
//                 />

//                 <Popper open={open} placement="bottom-start" anchorEl={searchRef.current} ref={popperRef} sx={{ zIndex: 100 }}>
//                     <Paper sx={{ width: '60vw', border: "1px solid #E0E0E0", marginTop: "16px", minHeight: "150px", maxHeight: "550px", overflow: "auto" }} onScroll={handleScroll} >
//                         <List className="px-4 py-3">
//                             {searchResults?.map((result, index) => (
//                                 <React.Fragment key={result.id}>
//                                     <ListItem className="d-flex flex-column align-items-start global_search_listitem m-0 p-0">

//                                         <div className="d-flex align-items-center justify-content-start w-100" style={{ minHeight: "112px" }}>
//                                             <div className="leftSide_container_global flex-center flex-column me-3">
//                                                 <Avatar
//                                                     src={result.profile_url}
//                                                     alt={result.first_name + ' ' + result.last_name}
//                                                     style={{ width: 100, height: 100 }}
//                                                 />
//                                                 {result.is_verified ? (
//                                                     <div className="verifiedcontainer flex-center">
//                                                         <div className="me-3">Verified</div>
//                                                         <div className="icon-verify-symbol flex-center">
//                                                             <VerifiedTickN />
//                                                         </div>
//                                                     </div>
//                                                 ) :
//                                                     <div className="verifiedcontainer flex-center" style={{ backgroundColor: "#EB4E3D", width: "106px" }}>
//                                                         <div className="me-3">Unverified</div>
//                                                         <div className="icon-verify-symbol flex-center">
//                                                             <NonVerifiedTickNew />
//                                                         </div>
//                                                     </div>}
//                                             </div>
//                                             <Box style={{ flexGrow: 1 }}>
//                                                 <div className="fw-bold heading-Lightbox-group">
//                                                     {result.first_name + ' ' + result.last_name}
//                                                 </div>
//                                                 <div className="group_permissions_subtitle my-2">
//                                                     {result.designation || result.field_of_study || result.title || '---'}
//                                                 </div>
//                                                 <div className="group_permissiions_options" style={{ fontSize: "12px" }}>
//                                                     {result.profession_department || result.institute || result.nickname || '---'}
//                                                 </div>
//                                             </Box>
//                                             <Box>
//                                                 {/* <Button variant="contained"> */}
//                                                 {result.relationship_status === 'ACCEPTED' ? (
//                                                     <Button
//                                                         variant="text"
//                                                         startIcon={<VisibilityIcon className="color-blue" color="color-blue" />}
//                                                         style={{ textTransform: 'none' }}
//                                                         onClick={() => { handleNavigate(result.reference_id) }}
//                                                         className="connect-button text-nowrap me-4"
//                                                     >
//                                                         VIEW PROFILE
//                                                     </Button>
//                                                 ) : result.relationship_status === 'PENDING' ? (
//                                                     <Button className="connect-button">SENT</Button>
//                                                 ) : (
//                                                     <Button className="connect-button" onClick={() => handleConnectRequest(result.reference_id, index)}>CONNECT</Button>
//                                                 )}

//                                                 {/* </Button> */}
//                                             </Box>
//                                         </div>
//                                         {/* {result?.card_details?.length > 0 &&
//                                             <div className="w-100 d-flex mt-3 gap-2 flex-wrap">
//                                                 {result?.card_details?.map((detail, idx) => (
//                                                     <Chip key={idx} label={detail} variant="outlined" />
//                                                 ))}
//                                             </div>
//                                         } */}
//                                     </ListItem>
//                                     {index < searchResults.length - 1 && <Divider className="mt-4 mb-1 Border_globalSearch" />}
//                                 </React.Fragment>
//                             ))}
//                             {loadingMore && (
//                                 <ListItem>
//                                     <ListItemText
//                                         primary="Loading more..."
//                                         style={{ textAlign: 'center' }}
//                                     />
//                                 </ListItem>
//                             )}

//                             {!hasMore && searchResults.length > 0 && (
//                                 <ListItem>
//                                     <ListItemText
//                                         primary="No more results"
//                                         style={{ textAlign: 'center', color: '#757575' }}
//                                     />
//                                 </ListItem>
//                             )}

//                             {!loadingMore && searchResults.length === 0 && (
//                                 <ListItem>
//                                     <ListItemText primary="No results found" />
//                                 </ListItem>
//                             )}
//                             {searchResults.length === 0 && (
//                                 <ListItem>
//                                     <ListItemText primary="No results found" />
//                                 </ListItem>
//                             )}
//                         </List>
//                     </Paper>
//                 </Popper>
//             </div>
//         </>
//     )
// }

// export default GlobalSearch;


import React, { useState, useRef, useEffect, useCallback } from "react";
import {
    Popper, Paper, List, ListItem, ListItemText, TextField, InputAdornment,
    Divider, Avatar, Box, Typography, Button, CircularProgress
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { ReactComponent as VerifiedTickN } from "../../../Assets/img/icons/Verified-icon-new.svg";
import Chip from '@mui/material/Chip';
import { ReactComponent as NonVerifiedTickNew } from "../../../Assets/img/icons/Non-verified-icon.svg";
import useApi from '../../Utilities/useAPI';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import axios from "axios";

const GlobalSearch = ({ setOpenSearch }) => {
    const objectId = localStorage.getItem("objectId");
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [initialFetchDone, setInitialFetchDone] = useState(false);
    const [open, setOpen] = useState(true);
    const searchRef = useRef(null);
    const popperRef = useRef(null);
    const [offset, setOffset] = useState(0); // Changed to 0 for better pagination
    const [loadingMore, setLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [isSearching, setIsSearching] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const abortControllerRef = useRef(null);
    const debounceTimerRef = useRef(null);
    const { callApiFunction } = useApi();
    const navigate = useNavigate();
    const LIMIT = 20;

    const handleClickOutsideSearch = (event) => {
        if (searchRef.current && !searchRef.current.contains(event.target) &&
            popperRef.current && !popperRef.current.contains(event.target)) {
            setOpenSearch(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutsideSearch);
        return () => {
            document.removeEventListener('mousedown', handleClickOutsideSearch);
            // Cleanup on unmount
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, []);

    const fetchSearchResults = async (query, offsetValue = 0, isLoadMore = false) => {
        // Cancel previous request if exists
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        // Create new abort controller
        abortControllerRef.current = new AbortController();

        try {
            if (isLoadMore) {
                setLoadingMore(true);
            } else {
                setIsSearching(true);
            }

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/usercontact/connection/search-get-user/`,
                {
                    params: {
                        searchParam: query,
                        limit: LIMIT,
                        offset: offsetValue,
                    },
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("objectId")}`,
                        "Content-Type": "application/json",
                    },
                    signal: abortControllerRef.current.signal,
                }
            );

            if (response?.data?.status === "SUCCESS") {
                const newResults = response?.data?.data || [];
                const total = response?.data?.total || 0;
                
                setTotalCount(total);
                setHasMore((offsetValue + LIMIT) < total);
                
                console.log(`Fetched ${newResults.length} results, Total: ${total}, HasMore: ${(offsetValue + LIMIT) < total}`);

                if (isLoadMore) {
                    setSearchResults((prev) => [...prev, ...newResults]);
                } else {
                    setSearchResults(newResults);
                }
                setOpen(true);
            }
        } catch (error) {
            if (error.name !== 'CanceledError' && error.name !== 'AbortError') {
                console.error("Error fetching search results:", error);
            }
        } finally {
            if (isLoadMore) {
                setLoadingMore(false);
            } else {
                setIsSearching(false);
            }
        }
    };

    const handleInputChange = (event) => {
        const newQuery = event.target.value;
        setSearchQuery(newQuery);
        
        // Clear previous debounce timer
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }

        // Reset pagination state for new search
        setOffset(0);
        setHasMore(true);
        setSearchResults([]);
        
        if (newQuery.trim() === "") {
            setOpen(false);
            setIsSearching(false);
            return;
        }

        // Set new debounce timer
        debounceTimerRef.current = setTimeout(() => {
            if (newQuery.trim() !== "") {
                fetchSearchResults(newQuery, 0, false);
            }
        }, 500); // 500ms debounce delay
    };

    // Trigger initial fetch on focus with empty query (or default 'a' as per your requirement)
    const handleFocus = async () => {
        if (!initialFetchDone) {
            // You can either fetch with empty string or 'a'
            await fetchSearchResults('', 0, false);
            setInitialFetchDone(true);
        }
    };

    const handleConnectRequest = async (contactRefId, index) => {
        const payload = {
            userrefid: objectId,
            contact_ref_id: contactRefId,
            relationship_type: "FRIEND",
        };

        try {
            const response = await callApiFunction('SendConnectRequest', payload);
            if (response.status === "SUCCESS") {
                const updatedResults = [...searchResults];
                updatedResults[index].relationship_status = "PENDING";
                setSearchResults(updatedResults);
            } else {
                console.error('Failed to send connection request.');
            }
        } catch (err) {
            console.error('An error occurred while sending the connection request:', err);
        }
    };

    const handleNavigate = (id) => {
        const encryptedId = CryptoJS.AES.encrypt(id.toString(), 'UserDetailsSecretKey').toString();
        navigate(`/AllCardsUser/${encodeURIComponent(encryptedId)}`);
        setOpenSearch(false);
    };

    const handleScroll = useCallback((e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        const isNearBottom = scrollHeight - scrollTop <= clientHeight + 100; // 100px threshold

        if (isNearBottom && !loadingMore && hasMore && !isSearching && searchQuery.trim() !== "") {
            const nextOffset = offset + LIMIT;
            setOffset(nextOffset);
            fetchSearchResults(searchQuery, nextOffset, true);
        }
    }, [loadingMore, hasMore, isSearching, searchQuery, offset]);

    return (
        <>
            <div ref={searchRef} className="header-search-container">
                <TextField
                    placeholder="Search for People"
                    variant="outlined"
                    size="small"
                    className="me-2"
                    value={searchQuery}
                    onChange={handleInputChange}
                    onFocus={handleFocus}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <div className="icon-svg-24 flex-center ml-0">
                                    <SearchIcon className="icon-color" />
                                </div>
                            </InputAdornment>
                        ),
                        endAdornment: isSearching && searchQuery.trim() !== "" && (
                            <InputAdornment position="end">
                                <CircularProgress size={20} />
                            </InputAdornment>
                        ),
                    }}
                    style={{ width: '320px' }}
                />

                <Popper 
                    open={open && (searchResults.length > 0 || isSearching)} 
                    placement="bottom-start" 
                    anchorEl={searchRef.current} 
                    ref={popperRef} 
                    sx={{ zIndex: 100 }}
                >
                    <Paper 
                        sx={{ 
                            width: '60vw', 
                            border: "1px solid #E0E0E0", 
                            marginTop: "16px", 
                            minHeight: "150px", 
                            maxHeight: "550px", 
                            overflow: "auto" 
                        }} 
                        onScroll={handleScroll}
                    >
                        <List className="px-4 py-3">
                            {searchResults.map((result, index) => (
                                <React.Fragment key={result.id || result.reference_id || index}>
                                    <ListItem className="d-flex flex-column align-items-start global_search_listitem m-0 p-0">
                                        <div className="d-flex align-items-center justify-content-start w-100" style={{ minHeight: "112px" }}>
                                            <div className="leftSide_container_global flex-center flex-column me-3">
                                                <Avatar
                                                    src={result.profile_url}
                                                    alt={result.first_name + ' ' + result.last_name}
                                                    style={{ width: 100, height: 100 }}
                                                />
                                                {result.is_verified ? (
                                                    <div className="verifiedcontainer flex-center">
                                                        <div className="me-3">Verified</div>
                                                        <div className="icon-verify-symbol flex-center">
                                                            <VerifiedTickN />
                                                        </div>
                                                    </div>
                                                ) :
                                                    <div className="verifiedcontainer flex-center" style={{ backgroundColor: "#EB4E3D", width: "106px" }}>
                                                        <div className="me-3">Unverified</div>
                                                        <div className="icon-verify-symbol flex-center">
                                                            <NonVerifiedTickNew />
                                                        </div>
                                                    </div>}
                                            </div>
                                            <Box style={{ flexGrow: 1 }}>
                                                <div className="fw-bold heading-Lightbox-group">
                                                    {result.first_name + ' ' + result.last_name}
                                                </div>
                                                <div className="group_permissions_subtitle my-2">
                                                    {result.designation || result.field_of_study || result.title || '---'}
                                                </div>
                                                <div className="group_permissiions_options" style={{ fontSize: "12px" }}>
                                                    {result.profession_department || result.institute || result.nickname || '---'}
                                                </div>
                                            </Box>
                                            <Box>
                                                {result.relationship_status === 'ACCEPTED' ? (
                                                    <Button
                                                        variant="text"
                                                        startIcon={<VisibilityIcon className="color-blue" color="color-blue" />}
                                                        style={{ textTransform: 'none' }}
                                                        onClick={() => { handleNavigate(result.reference_id) }}
                                                        className="connect-button text-nowrap me-4"
                                                    >
                                                        VIEW PROFILE
                                                    </Button>
                                                ) : result.relationship_status === 'PENDING' ? (
                                                    <Button className="connect-button" disabled>SENT</Button>
                                                ) : (
                                                    <Button className="connect-button" onClick={() => handleConnectRequest(result.reference_id, index)}>
                                                        CONNECT
                                                    </Button>
                                                )}
                                            </Box>
                                        </div>
                                        {/* {result?.card_details?.length > 0 &&
                                            <div className="w-100 d-flex mt-3 gap-2 flex-wrap">
                                                {result?.card_details?.map((detail, idx) => (
                                                    <Chip key={idx} label={detail} variant="outlined" />
                                                ))}
                                            </div>
                                        } */}
                                    </ListItem>
                                    {index < searchResults.length - 1 && <Divider className="mt-4 mb-1 Border_globalSearch" />}
                                </React.Fragment>
                            ))}
                            
                            {/* Loading More Indicator */}
                            {loadingMore && (
                                <ListItem>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', py: 2 }}>
                                        <CircularProgress size={30} />
                                    </Box>
                                </ListItem>
                            )}

                            {/* No More Results Message */}
                            {!hasMore && searchResults.length > 0 && !loadingMore && (
                                <ListItem>
                                    <ListItemText
                                        primary="No more results"
                                        style={{ textAlign: 'center', color: '#757575' }}
                                    />
                                </ListItem>
                            )}

                            {/* Initial Loading State */}
                            {isSearching && !loadingMore && searchResults.length === 0 && (
                                <ListItem>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', py: 4 }}>
                                        <CircularProgress size={40} />
                                    </Box>
                                </ListItem>
                            )}

                            {/* No Results Found */}
                            {!isSearching && !loadingMore && searchResults.length === 0 && searchQuery.trim() !== "" && (
                                <ListItem>
                                    <ListItemText 
                                        primary="No results found" 
                                        style={{ textAlign: 'center', color: '#757575' }}
                                    />
                                </ListItem>
                            )}

                            {/* Empty State - No Search Query */}
                            {searchQuery.trim() === "" && searchResults.length === 0 && !isSearching && (
                                <ListItem>
                                    <ListItemText 
                                        primary="Start typing to search for people" 
                                        style={{ textAlign: 'center', color: '#757575' }}
                                    />
                                </ListItem>
                            )}
                        </List>
                    </Paper>
                </Popper>
            </div>
        </>
    )
}

export default GlobalSearch;